/* HPH Article extras (Aug 10, 2026)
   1. FAQ accordion: upgrades the article's FAQ section (an h2 followed by h3+p pairs
      inside the prose) into an accessible click-to-open accordion. Progressive
      enhancement: without JS the FAQ stays plain readable headings + paragraphs.
   2. Table scroll: wraps every prose table in an overflow container so wide tables
      scroll horizontally on mobile instead of breaking the page.
   No innerHTML anywhere: all nodes are built with DOM methods (content comes from the
   article body, which is our own, but belt and braces). */
(function () {
  'use strict';

  var SVG_NS = 'http://www.w3.org/2000/svg';

  function init() {
    var prose = document.querySelector('.hph-article__prose');
    if (!prose) return;
    buildFaqAccordion(prose);
    wrapTables(prose);
    newTabLinks(prose);
  }

  /* Shop links (products/collections), external sources and WhatsApp open in a new
     tab so the reader never loses the article. Blog-to-blog links and tel: stay in
     the same tab (natural reading flow). */
  function newTabLinks(prose) {
    prose.querySelectorAll('a[href]').forEach(function (a) {
      var href = a.getAttribute('href') || '';
      var external = /^https?:\/\//.test(href) && a.hostname !== window.location.hostname;
      var shop = href.indexOf('/products/') === 0 || href.indexOf('/collections/') === 0;
      if (external || shop) {
        a.setAttribute('target', '_blank');
        a.setAttribute('rel', 'noopener');
      }
    });
  }

  function isFaqHeading(el) {
    if (!el || el.tagName !== 'H2') return false;
    var t = (el.textContent || '').toLowerCase();
    return t.indexOf('faq') !== -1 || t.indexOf('always ask') !== -1 || t.indexOf('frequently asked') !== -1;
  }

  function chevron() {
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('class', 'hph-afaq__chevron');
    svg.setAttribute('width', '18');
    svg.setAttribute('height', '18');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    var poly = document.createElementNS(SVG_NS, 'polyline');
    poly.setAttribute('points', '6 9 12 15 18 9');
    svg.appendChild(poly);
    return svg;
  }

  function buildFaqAccordion(prose) {
    var headings = prose.querySelectorAll('h2');
    var faqH2 = null;
    for (var i = 0; i < headings.length; i++) {
      if (isFaqHeading(headings[i])) { faqH2 = headings[i]; break; }
    }
    if (!faqH2) return;

    // Collect the section: h3 questions, each followed by its answer nodes,
    // until the next h2 or an hr.
    var items = [];
    var node = faqH2.nextElementSibling;
    var current = null;
    while (node && node.tagName !== 'H2' && node.tagName !== 'HR') {
      var next = node.nextElementSibling;
      if (node.tagName === 'H3') {
        current = { q: node, a: [] };
        items.push(current);
      } else if (current) {
        current.a.push(node);
      }
      node = next;
    }
    if (!items.length) return;

    faqH2.classList.add('hph-afaq__heading');

    var list = document.createElement('div');
    list.className = 'hph-afaq';

    items.forEach(function (item, idx) {
      var entry = document.createElement('div');
      entry.className = 'hph-afaq__item';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'hph-afaq__q';
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-controls', 'hph-afaq-panel-' + idx);
      var qText = document.createElement('span');
      qText.className = 'hph-afaq__q-text';
      qText.textContent = item.q.textContent;
      btn.appendChild(qText);
      btn.appendChild(chevron());

      var panel = document.createElement('div');
      panel.className = 'hph-afaq__panel';
      panel.id = 'hph-afaq-panel-' + idx;
      var inner = document.createElement('div');
      inner.className = 'hph-afaq__panel-inner';
      item.a.forEach(function (n) { inner.appendChild(n); });
      panel.appendChild(inner);

      btn.addEventListener('click', function () {
        var open = entry.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      entry.appendChild(btn);
      entry.appendChild(panel);
      list.appendChild(entry);
      item.q.remove();
    });

    faqH2.after(list);
  }

  function wrapTables(prose) {
    prose.querySelectorAll('table').forEach(function (table) {
      if (table.parentElement && table.parentElement.classList.contains('hph-prose-table')) return;
      var wrap = document.createElement('div');
      wrap.className = 'hph-prose-table';
      table.before(wrap);
      wrap.appendChild(table);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
